export const SS_TOKEN = 'token';
export const LS_USER = 'user';
export const LS_LANGUAGE = 'language';